import { I18nComponente } from "@/types/gerais"

export const OCriarAtributoi18n: I18nComponente = {
  "pt-BR": {
    nomeDoAtributo: "nome do atributo*",
    naturezaDoAtributo: "natureza do atributo*",
    tipoDeValor: "tipo de valor*",
    permitirSelecionarApenasUmItem: "permitir selecionar apenas um item",
    valoresPossiveisSeparePorVirgula: "valores possíveis (separe por vírgula)",
    salvarAdicionarNovoAtributo: "salvar e adicionar novo atributo",
    campoObrigatorio: "campo obrigatório",
    caracteristica: "característica",
    capacidade: "capacidade",
    codigoIdentificador: "código identificador",
    numeroInteiro: "número inteiro",
    numeroDecimal: "número decimal",
    texto: "texto",
    itensDeLista: "itens de lista",
    data: "data",
    horario: "horário",
    quantidadeInteira: "quantidade inteira",
    quantidadeDecimal: "quantidade decimal",
    quantidadeDeHoras: "quantidade de horas",
    sucesso: "Sucesso",
    atributoCriado: "Atributo criado!",
    erro: "Erro",
    naoFoiPossivelCriarAtributo: "Não foi possível criar o atributo!",
    camposInvalidos: "Campos inválidos",
    preenchaOsCamposAlertadosCorretamente: "Preencha os campos alertados corretamente",
    voltar: "voltar",
  },
  "es-CO": {
    nomeDoAtributo: "nombre del atributo*",
    naturezaDoAtributo: "clasificación del atributo*",
    tipoDeValor: "tipo de valor*",
    permitirSelecionarApenasUmItem: "permitir seleccionar solo un ítem",
    valoresPossiveisSeparePorVirgula: "valores posibles (separe por coma)",
    salvarAdicionarNovoAtributo: "guardar y añadir nuevo atributo",
    campoObrigatorio: "campo obligatorio",
    caracteristica: "característica",
    capacidade: "capacidad",
    codigoIdentificador: "código identificador",
    numeroInteiro: "número entero",
    numeroDecimal: "número decimal",
    texto: "texto",
    itensDeLista: "ítems de lista",
    data: "fecha",
    horario: "hora",
    quantidadeInteira: "cantidad entera",
    quantidadeDecimal: "cantidad decimal",
    quantidadeDeHoras: "cantidad de horas",
    sucesso: "Éxito",
    atributoCriado: "¡Atributo creado!",
    erro: "Error",
    naoFoiPossivelCriarAtributo: "¡No fue posible añadir el atributo!",
    camposInvalidos: "Campos inválidos",
    preenchaOsCamposAlertadosCorretamente: "Rellene los campos alertados correctamente",
    voltar: "volver",
  },
}
